import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";

import { useState } from "react";
import ApprovalIcon from "@mui/icons-material/Approval";
import ConfirmModal from "../modals/ConfirmModal";
import { CancelLockupProposal } from "../../../../../apis/__generated__/graphql";

export interface ConfirmButtonProps {
  refetch: () => void;
  row?: CancelLockupProposal;
  disabled: boolean;
  onSelectedRow: () => void;
  onUnselectedRow: () => void;
}

export default function ConfirmButton({
  refetch,
  row,
  disabled,
  onSelectedRow,
  onUnselectedRow,
}: ConfirmButtonProps) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    onSelectedRow();
  };

  const handleClose = () => {
    setOpen(false);
    onUnselectedRow();
  };

  return (
    <>
      <GridActionsCellItem
        label="Confirm"
        icon={
          <Tooltip title="Confirm">
            <ApprovalIcon />
          </Tooltip>
        }
        onClick={handleOpen}
        disabled={disabled}
      />
      {row && (
        <ConfirmModal
          row={row}
          open={open}
          onClose={handleClose}
          refetch={refetch}
        />
      )}
    </>
  );
}
